export default "__VITE_ASSET__BWSBiZAs__"